import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ErrorServer } from '@packages/fenrir/feedback';

export const UnavailablePage = () => {
  const { t } = useTranslation('custom-alerts');
  const params = useParams();
  const orgId = params?.organizationId ?? '';

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <ErrorServer
      actionLink={{
        label: t('error.button-text'),
        to: `/${orgId}`,
      }}
      reloadOnClick={refreshPage}
    />
  );
};
